import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AccountInfo } from "@azure/msal-browser";

interface AuthState {
  user: AccountInfo | null;
  isAuthenticated: boolean;
}

const initialState: AuthState = {
  user: null,
  isAuthenticated: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<AccountInfo>) => {
      state.user = action.payload;
      state.isAuthenticated = true;
    },
    clearUser: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      // Clear user_id from localStorage
      localStorage.removeItem('user_id');
    },
  },
});

export const { setUser, clearUser } = authSlice.actions;
export default authSlice.reducer;
